
import { h, Fragment } from 'preact'; /** @jsx h */

import { ROUTES } from '@pyqml/shared';

import { Layout } from '../components/Layout';

import { useAuth } from '../app/AuthProvider';
import { useEffect, useState } from 'preact/hooks';

export const Unsubscribe = (props) => {
    
    const urlParams = new URLSearchParams(window.location.search);
    const queryEmtkn = urlParams.get("emtkn");

    const [result, setResult] = useState<boolean | undefined>(undefined);    
    const { authPromise } = useAuth();
    
	
    useEffect(() => {

        authPromise?.({
            method: "post",
            endpoint: ROUTES.CLOUDAPI_PUBLIC_UNSUBSCRIBE_FREE_COURSE,
            queryData: {
                emailId: queryEmtkn
            }
        }).then(response => {
            console.log("response", response);

            setResult(response?.status === 200)
        }).catch(err => {
            console.log("error", err);
            setResult(false);
        });

		
    }, []);

    return <Layout.Stacked>
        <Layout.Section weight="equal">
            <h1 className="secondfont mb-3 font-weight-bold">
                Sorry to see you go
            </h1>
            <p>
                {
                    result === undefined
                        ? "Unsubscribing..."
                        : result
                            ? "You have been unsubscribed from the PyQML newsletter. We are sorry to see you go, but we understand that sometimes you just need a break."
                            : "We could not unsubscribe you from the PyQML newsletter. Please try again later."
                }
            </p>
        </Layout.Section>
    </Layout.Stacked>
            
}
  
